import React, { useState, useEffect } from 'react'
import { Grid, Typography, CircularProgress } from '@material-ui/core'
import { makeStyles } from '@material-ui/styles'
import MUIDataTable from 'mui-datatables'

// components
import Widget from '../../components/Widget'

import {
    getLGFBuyBacks,
    getLGFBuyBacksPrice,
    getLGFBuyBacksDataTable,
} from './utils.js'

import axios from 'axios'

const useStyles = makeStyles(theme => ({
    tableOverflow: {
        overflow: 'auto',
    },
}))

// Contracts
const JPG_CONTRACT = '0x19e5bb63c902c0690d1ba9b946ee8920e8dec3c6'
const Farming_Contract = '0x0B9d6b075e2e8816545d8b24e4651F4C8643f234'

// Create our number formatter.
var formatter = new Intl.NumberFormat()

var formatterUS = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
})

async function transfers(chainId, contract, wallet) {
    try {
        return await axios.get(
            `https://effortless-leaf-336220.uc.r.appspot.com/transfers_v2/${wallet}/${contract}/${chainId}`
        )
    } catch (error) {
        console.error(error.message)
    }
}

export default function BuyBacksPage() {
    const classes = useStyles()

    const [lgfBuyBacks, setLGFBuyBacks] = useState(0)
    const [lgfBuyBacksPrice, setLGFBuyBacksPrice] = useState(0)

    const [lgfBuyBacksLoader, setLGFBuyBacksLoader] = useState(0)

    const [datatableData, setDatatableData] = useState([])

    useEffect(() => {
        const fetchTransfers = async (contract, wallet) => {
            setLGFBuyBacksLoader(1)
            setDatatableData([])
            try {
                const response = await transfers(1, contract, wallet)
                const number = getLGFBuyBacks(response)
                const price = getLGFBuyBacksPrice(response)
                const datatable = getLGFBuyBacksDataTable(response)
                setLGFBuyBacks(number)
                setLGFBuyBacksPrice(price)
                setDatatableData(datatable)
            } catch (error) {
                console.error(error.message)
            }
            setLGFBuyBacksLoader(0)
        }

        const refresh = async () => {
            await fetchTransfers(JPG_CONTRACT, Farming_Contract)
        }

        refresh()
    }, [])

    return (
        <>
            <Grid container spacing={4}>
                <Grid item xs={12} md={4}>
                    <Widget title="Number of Buybacks" disableWidgetMenu>
                        <div className={classes.dashedBorder}>
                            <Typography variant="h1" className={classes.text}>
                                {!lgfBuyBacksLoader ? (
                                    formatter.format(lgfBuyBacks)
                                ) : (
                                    <CircularProgress
                                        size={26}
                                        className={classes.loginLoader}
                                    />
                                )}
                            </Typography>
                        </div>
                    </Widget>
                </Grid>
                <Grid item xs={12} md={4}>
                    <Widget title="Total Amount (USD)" disableWidgetMenu>
                        <div className={classes.dashedBorder}>
                            <Typography variant="h1" className={classes.text}>
                                {!lgfBuyBacksLoader ? (
                                    formatterUS.format(lgfBuyBacksPrice)
                                ) : (
                                    <CircularProgress
                                        size={26}
                                        className={classes.loginLoader}
                                    />
                                )}
                            </Typography>
                        </div>
                    </Widget>
                </Grid>
                <Grid item xs={12} md={4}>
                    <Widget title="Average Buyback (USD)" disableWidgetMenu>
                        <div className={classes.dashedBorder}>
                            <Typography variant="h1" className={classes.text}>
                                {!lgfBuyBacksLoader ? (
                                    formatterUS.format(
                                        lgfBuyBacks > 0
                                            ? lgfBuyBacksPrice / lgfBuyBacks
                                            : 0
                                    )
                                ) : (
                                    <CircularProgress
                                        size={26}
                                        className={classes.loginLoader}
                                    />
                                )}
                            </Typography>
                        </div>
                    </Widget>
                </Grid>
            </Grid>
            <Grid container spacing={4}>
                <Grid item xs={12}>
                    <MUIDataTable
                        title="Buyback Ledger"
                        data={datatableData}
                        columns={[
                            {
                                name: 'Date',
                            },
                            {
                                name: 'Amount (ETH)',
                            },
                            {
                                name: 'Amount (USD)',
                            },
                            {
                                name: 'Tx Hash',
                                options: {
                                    customBodyRender: (
                                        value,
                                        tableMeta,
                                        updateValue
                                    ) => {
                                        return (
                                            <a
                                                target="_blank"
                                                href={
                                                    'https://etherscan.io/tx/' +
                                                    value
                                                }
                                            >
                                                {value}
                                            </a>
                                        )
                                    },
                                },
                            },
                        ]}
                        options={{
                            filterType: 'checkbox',
                            selectableRowsHeader: false,
                            selectableRows: 'none',
                            print: false,
                            textLabels: {
                                body: {
                                    noMatch: lgfBuyBacksLoader ? (
                                        <CircularProgress
                                            size={26}
                                            className={classes.loginLoader}
                                        />
                                    ) : (
                                        'Sorry, there is no data to display'
                                    ),
                                },
                            },
                        }}
                    />
                </Grid>
            </Grid>
            {/* <Grid container spacing={4}>
        <Grid item xs={12}>
          <Widget
            title="Material-UI Table"
            upperTitle
            noBodyPadding
            bodyClass={classes.tableOverflow}
          >
            <Table data={mock.table} />
          </Widget>
        </Grid>
      </Grid> */}
        </>
    )
}
